import { onSetCookie } from "@solvari/utils";

import { createArgusEvent } from "@/client/createArgusEvent";

function addInitEvent() {
  return createArgusEvent("init", { userAgent: window.navigator.userAgent });
}

function initCookieConsentListener() {
  onSetCookie(
    "solvariCookieConsent",
    (consentTypes) => void createArgusEvent("cookie_consent", { consentTypes }),
  );
}

export { addInitEvent, initCookieConsentListener };
